module.exports = __webpack_public_path__ + "static/media/connection_service_region_3.224020a5.png";